export default {
  path: '/usuario/:id',
  component: () => import('@/components/dialog/UserInfo')
}
